export default __webpack_public_path__ + "static/media/sad_emoji_animated.57c9596c.gif";